import Twig from 'twig';

const NAMES = ['offdays', 'free', 'busy', 'block'];
let registered = false;

/** Регистрируем twig-шаблоны строк один раз за всё время жизни страницы */
export function registerScheduleTemplates() {
    if (registered) return;
    NAMES.forEach((name) => {
        Twig.twig({
            id: `schedule-doctor-item-${name}`,
            href: `/twig/s-doctor-item-${name}.twig`,
            async: false,
        });
    });
    registered = true;
}

export function renderTemplate(name, data) {
    return Twig.twig({ ref: `schedule-doctor-item-${name}` }).render(data);
}
